enum ShareOptionValues {
  EVERYONE = "everyone",
  PRIVATE = "private",
  TEAMS = "teams"
}

export default ShareOptionValues